import React from 'react';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';

import { Label } from 'core/components/label';
import { Card } from 'core/components/card';
import AddButton from 'core/components/add-button';
import RemoveButton from 'core/components/remove-button';

import savingsOn from 'core/assets/svg/ic-savings-on.svg';
import savingsOff from 'core/assets/svg/ic-savings-off.svg';

import useStyles from './community-drive-card.styles';

const getDriverDisplayName = (firstName, lastName) => {
  return `${firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase()} ${lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase()}`;
};

const OfferCommunityDriveCard = observer(({ driver, isParticipating, onChange }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.communityDriveAvailable}>
      <Card type={isParticipating ? 'outlineBeige' : 'light'} className={classes.card}>
        <Grid className={classes.columnContainer}>
          <Grid container className={classes.communityDriveInfoContainer}>
            <Grid item className={classes.labelAndToolTip}>
              <img className={classes.savingsIcon} src={isParticipating ? savingsOn : savingsOff} alt="Savings Icon" />
              <Label type="notificationText" className={classes.driverName}>
                {getDriverDisplayName(driver.firstName, driver.lastName)}
              </Label>
            </Grid>
            <Grid className={classes.scoreContainer1stTerm}>
              {isParticipating ? (
                <RemoveButton className={classes.noBoxShadow} onClick={() => onChange(false)} />
              ) : (
                <AddButton type="full" className={classes.noBoxShadow} onClick={() => onChange(true)} />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
});

export default OfferCommunityDriveCard;
